var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-link-area"},[(_vm.unitData.data && _vm.unitData.data.image)?_c('img',{attrs:{"src":_vm.unitData.data.image,"alt":""}}):_c('p',{staticClass:"unit-empty"},[_vm._v("未设置图片")])])}
var staticRenderFns = []

export { render, staticRenderFns }